<template>
  <div>
    <my-head></my-head>
    <div class="minH details">
      <div class="crumbs">
        首页 > 成交公告 >
        <span style="color: #1d2129">项目成交详情</span>
      </div>
      <div class="det_cont">
        <deal-col class="col" :cData="froms"></deal-col>
        <el-divider></el-divider>
        <div class="from_style">
          <el-form :label-width="labelWath">
            <el-form-item label="项目所在国家/地区："> 上海 </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="权证编号：">
              {{ froms.warrantCode }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="知识产权类别："
              >{{ froms.propertyCategory }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="交易转让方：">
              {{ froms.identityName }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="交易方式：">
              {{ froms.paymentType }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="挂牌价格：">
              {{ froms.floorPrice ? priceCurrencyPrefix(froms.foreignType || froms.floorPriceUnit) + " " + froms.floorPrice + "万元" : "面议" }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="成交时间：">
              {{ froms.createTime | dateSy('YYYY-MM-DD') }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="成交价格：">
              {{ froms.dealPrice ? priceCurrencyPrefix(froms.foreignType || froms.floorPriceUnit) + " " + froms.dealPrice + "万元" : "面议" }}
            </el-form-item>
          </el-form>

          <el-form :label-width="labelWath">
            <el-form-item label="受托机构：">
              上海知识产权交易中心
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import DealCol from "../../components/DealCol.vue";
import { getRequest } from "../../api/api";
import { formatDate, priceCurrencyPrefix } from "../../api/util";
export default {
  components: { MyHead, MyFooter, DealCol },
  data() {
    return {
      froms: {},
      labelWath: "300px",
    };
  },
  //过滤器
  filters: {
    formatDate(val) {
      return formatDate(val);
    },
  },
  methods: {
    priceCurrencyPrefix,
    getFrom() {
      getRequest({ url: `/api/v1/done/detail/${this.$route.query.id}` }).then(
        (res) => {
          if (res.errcode == 200) {
            this.froms = res.data;
          }
        }
      );
    },
  },
  created() {
    this.getFrom();
  },
};
</script>

<style lang="scss">
.details {
  width: 80%;
  margin: 24px auto 60px;
  .det_cont {
    border: #cccccc solid 1px;
    border-radius: 5px;
    .el-form-item__label,
    .el-form-item__content {
      font-size: 16px;
    }
    .el-form-item {
      margin-bottom: 12px;
    }
    .col {
      border: none;
    }
  }
  .crumbs {
    font-size: 12px;
    color: #86909c;
    margin-bottom: 35px;
  }
}
</style>
